import React from 'react';
import SessionStore from 'stores/SessionStore';
import UserActionCreators from 'actions/UserActionCreators';

const Login = () => {
  return (
    <div className="absolute p-6 top-0 right-0">
      <a href="/login" className="text-white">
        Login
      </a>
    </div>
  );
}

const Logout = () => {
  return (
    <div className="absolute p-6 top-0 right-0">
      <a href="#" onClick={() => UserActionCreators.logout()} className="text-white">
        Logout
      </a>
    </div>
  );
}

const TrackingHeader = (props) => {
  if (!SessionStore.isQuotesOnly() && SessionStore.isLoggedIn()) return null;

  return (
    <div className="flex bg-blue-darker">
      <div className="flex justify-center w-full">
        <a href="https://www.cargomatic.com" target="_new">
          <img
            width="200"
            src="https://cargomatic.com/wp-content/uploads/2020/07/Cargomatic-Logo-Hi-Res-White.png"
            alt="Cargomatic"
          />
        </a>
        {!SessionStore.isLoggedIn() && <Login />}
        {SessionStore.isLoggedIn() && <Logout />}
      </div>
    </div>
  );
};

module.exports = TrackingHeader
